import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";
import type { TeamMember } from "../types/team";

export function useMembers() {
  return useQuery<TeamMember[], Error>({
    queryKey: ["team-members"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_tenant_members");

      if (error) {
        throw new Error(error.message);
      }

      return data as TeamMember[];
    },
  });
}
